import { withStyles } from '@material-ui/core';
import Detail from './common/Detail';
import { pluralize } from '../DriverPopUp/common/utils';
import { formatDeliveryOrServiceWindow } from '../../utils/utils';

const styles = (theme) => ({
  container: {
    margin: '16px 0px'
  },
  detailsContainer: {
    display: 'flex',
    marginBottom: 16
  },
  customContainer: {
    width: '33%',
    marginRight: 8
  }
});
const StopDetails = ({ classes, stopData }) => {
  return (
    <div className={classes.container}>
      <div className={classes.detailsContainer}>
        <Detail
          label="Arrival Time"
          value={stopData.arrivalTime}
          detailContainerClasses={classes.customContainer}
        />
        <Detail
          label="Departure Time"
          value={stopData.departureTime}
          detailContainerClasses={classes.customContainer}
        />
      </div>
      <div className={classes.detailsContainer}>
        <Detail
          label="Stop Time"
          value={stopData.stopTimeMinutes ? pluralize(stopData.stopTimeMinutes, 'MIN', 'S') : ''}
          detailContainerClasses={classes.customContainer}
        />
        <Detail
          label="Del Window"
          value={formatDeliveryOrServiceWindow(stopData.deliveryWindow)}
          detailContainerClasses={classes.customContainer}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(StopDetails);
